import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Divider,
  Checkbox,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const PostEditorAddtoQueueModal = ({ loading, onClose, onConfirm }) => {
  const { t } = useTranslation(["planner", "common"]);
  const [acknowledged, setAcknowledged] = useState(false);

  const handleConfirm = useCallback(() => {
    onConfirm(acknowledged);
  }, [onConfirm, acknowledged]);

  return (
    <Modal
      onClose={onClose}
      isOpen
      scrollBehavior="outside"
      autoFocus={false}
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader mt="2" fontSize="lg">
          {t("add_to_queue")}
        </ModalHeader>
        <ModalBody pb="0" position="relative">
          <Divider mt="0" />
          <Text mb="2">{t("add_to_queue_modal.title")}</Text>
          <Text color="gray.200" mb="6" fontSize="sm">
            {t("add_to_queue_modal.description")}
            <Link
              href="https://help.simplified.co/en/articles/6097903-how-to-add-posts-to-the-queue"
              isExternal
              sx={{ textTransform: "lowercase" }}
            >
              {t("learn_more", { ns: "common" })}
            </Link>
            .
          </Text>
          <Checkbox
            isChecked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
            fontSize="sm"
          >
            {t("add_to_queue_modal.skip_next_time")}
          </Checkbox>
          <Divider mb="0" />
        </ModalBody>
        <ModalFooter
          justifyContent="flex-end"
          w="full"
          alignItems="center"
          py="5"
        >
          <Button onClick={onClose} size="sm">
            {t("cancel", { ns: "common" })}
          </Button>
          <Button
            onClick={handleConfirm}
            isLoading={loading}
            size="sm"
            variant="solid"
            ml="4"
          >
            {t("add_to_queue")}
          </Button>
        </ModalFooter>
        <ModalCloseButton mr="2" mt="3" />
      </ModalContent>
    </Modal>
  );
};

PostEditorAddtoQueueModal.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

PostEditorAddtoQueueModal.defaultProps = {
  loading: false,
};

export default PostEditorAddtoQueueModal;
